import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { organizationServices } from '@hero/services';

export const useCreateInvite = options => {
  const queryClient = useQueryClient();

  return useMutation(body => organizationServices.createInvite(body), {
    ...options,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.useGetOrganizationUsers]
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.useGetOrganizationUserCount]
      });
      options?.onSuccess?.();
    }
  });
};
